import { render, staticRenderFns } from "./td-UserOpt.vue?vue&type=template&id=1982cd6a"
import script from "./td-UserOpt.vue?vue&type=script&lang=js"
export * from "./td-UserOpt.vue?vue&type=script&lang=js"
import style0 from "./td-UserOpt.vue?vue&type=style&index=0&id=1982cd6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports